/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import Dropdown from 'react-bootstrap/Dropdown';

import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';

import { isMobile } from '../../components/breakpoints';

import { IEshopSiteMenuViewProps } from './eshop-site-menu';

import { ILanguagesData, ISubMenuData, ISubMenuLinkData } from './eshop-site-menu.props.autogenerated';

import Popup from './../../components/eshop-popup';


export class EshopSiteMenuView extends React.PureComponent<IEshopSiteMenuViewProps> {
  public state: any = { hasMounted: false, isMobileExpand: false, width: 0, isSearchExpand: false, showPopup: false, showExternalLinkPopup: false };

  public componentDidMount(): void {
    if (!this.state.hasMounted) {
      window.addEventListener('resize', this._updateDimensions);

      this.setState({ hasMounted: true, width: window.innerWidth });
    }
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this._updateDimensions);
  }

  // public handleClick(buttonId:string): void {
  //   const { cartUrl, signInUrl } = this.props;

  //   let navigateTo = '#';

  //   if (buttonId === 'CART') {
  //     navigateTo = cartUrl;
  //   } else if (buttonId === 'SIGNIN') {
  //     navigateTo = signInUrl;
  //   }

  //   console.log(navigateTo);

  //   window.location.assign(navigateTo);
  // }

  public render(): JSX.Element | null {
    if (!this.state.hasMounted) {
      return null;
    }

    const { homeUrl, config } = this.props;

    const border = config.borderImage?.src ? { backgroundImage: `url(${config.borderImage.src})` } : { backgroundImage: '' };
    const logo = config.logoImage?.src ? <img src={config.logoImage.src} alt='' role='presentation' /> : '';
    const iso = config.isoImage?.src ? <img src={config.isoImage.src} alt='' role='presentation' /> : '';
    const locale = this.props.context.actionContext.requestContext.locale;

    if (isMobile(this.state.width)) {
      return (
        <div className='ecomm-main-menu-wrapper'>
          <div id='mobile-top' className='ecomm-main-menu mobile'>
            <Navbar expand='lg' onToggle={this._onToggleCallback} expanded={this.state.isMobileExpand}>
              <div className='header-wrapper'>
                <Navbar.Brand href={homeUrl} onClick={this._handleSiteLinkClick}>{logo}</Navbar.Brand>
                <Popup showPopup={this.state.showPopup} name='logo' url={homeUrl} isMobile={isMobile(this.state.width)} isPortalPopup={true} locale={locale} callback={this._handleCallback} context={this.props.context} />
                <Navbar.Toggle aria-controls='basic-navbar-nav' />
                {this.state.isMobileExpand ? this._renderLanguageMenu() : this._renderMobileActions()}
              </div>
              <Navbar.Collapse id='basic-navbar-nav'>
                <Nav className='h-100'>
                  <div className='quicklinks-wrapper'>
                    {this._renderQuicklinksMenu()}
                  </div>
                  <div className='sitelinks-wrapper'>{this._renderMainLevel()}</div>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
            {this.state.isSearchExpand && <div className="eshop-site-menu-search-expand">{this._renderReactFragment(this.props.search)}</div>}
          </div>
        </div>
      );
    }

    return (
      <div className='ecomm-main-menu-wrapper'>
        <div id='site-top' className='ecomm-main-menu desktop'>
          <div className='border' style={border} />
          <Navbar>
            {/* <Navbar.Brand href={homeUrl}>{logo}</Navbar.Brand> */}
            <div className='logo-wrapper'><a href={homeUrl} onClick={this._handleSiteLinkClick} className='logo'>{logo}</a></div>
            {iso}
            <Popup showPopup={this.state.showPopup} name='logo' url={homeUrl} isMobile={isMobile(this.state.width)} isPortalPopup={true} locale={locale} callback={this._handleCallback} context={this.props.context} />
            <Navbar.Collapse id='basic-navbar-nav'>
              <Nav>
                {this._renderMainLevel()}
                {this._renderActions()}
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          <div className='sub-menu row'>
            <div className='quicklinks-wrapper col-sm-10'>
              <p className='label'></p>
              {this._renderQuicklinksMenu()}
            </div>
            {this._renderLanguageMenu()}
          </div>
        </div>
      </div>
    );
  }

  private _renderMobileActions(): JSX.Element | null {
    const { cartUrl, config } = this.props;

    return (
      <div className="actions-wrapper">
        <Nav.Link className="action action--search" href="#" onClick={this._onToggleSearch} />
        {config.showCartButton && <Nav.Link className="action action--cart" href={cartUrl}>
          <p>{config.cartTitle}</p>
        </Nav.Link>}
        {this._renderAccountDropdownMobile()}
      </div>
    );
  }

  private _renderActions(): JSX.Element | null {
    const { cartUrl, config } = this.props;

    return (
      <div className="actions-wrapper">
        {!this.state.isSearchExpand && !this.state.isMobile && <Nav.Link className="action action--search" href="#" onClick={this._onToggleSearch} />}
        {this.state.isSearchExpand && !this.state.isMobile && <div className="eshop-site-menu-search-expand">{this._renderReactFragment(this.props.search)}
        </div>}
        {this.state.isSearchExpand && !this.state.isMobile && <button className="search_close_button" onClick={this._onToggleSearch}></button>}
        {config.showCartButton && <Nav.Link className="action action--cart" href={cartUrl}>
          <p>{config.cartTitle}</p>
        </Nav.Link>}
        {this._renderAccountDropdown()}
      </div>
    );
  }

  private _renderAccountDropdownMobile(): JSX.Element | null {
    const { config, data: { accountInformation }, context: { request: { user } } } = this.props;

    const customer = accountInformation?.result;

    // Debugging: Comment the line above and uncomment the line below.
    // const customer = { Name: 'hahhahhaha wwww', FirstName: 'hahhahhaha', LastName: 'wwww' };

    const first = customer && customer.FirstName ? customer.FirstName.charAt(0).toUpperCase() : '';
    const last = customer && customer.LastName ? customer.LastName.charAt(0).toUpperCase() : '';

    if (customer) {
      const initials = `${first + last}`;

      return (
        <NavDropdown title={initials} id="basic-nav-dropdown" className='account'>
          <NavDropdown.Item href={user && config.editProfileUrl.linkUrl ? config.editProfileUrl.linkUrl.destinationUrl : ''}>{config.editProfileUrl.linkText}</NavDropdown.Item>
          <NavDropdown.Item href={user && config.orderHistoryUrl.linkUrl ? config.orderHistoryUrl.linkUrl.destinationUrl : ''}>{config.orderHistoryUrl.linkText}</NavDropdown.Item>
          <NavDropdown.Item href={user && user.signOutUrl || ''}>{config.signOutTitle}</NavDropdown.Item>
        </NavDropdown>
      );
    }

    return <Nav.Link className='action action--sign-in' href={user && user.signInUrl}></Nav.Link>;
  }

  private _renderAccountDropdown(): JSX.Element | null {
    const { config, data: { accountInformation }, context: { request: { user } } } = this.props;

    const customer = accountInformation?.result;

    // Debugging: Comment the line above and uncomment the line below.
    // const customer = { Name: 'hahhahhaha wwww', FirstName: 'hahhahhaha', LastName: 'wwww' };

    const first = customer && customer.FirstName ? customer.FirstName.charAt(0).toUpperCase() : '';
    const last = customer && customer.LastName ? customer.LastName.charAt(0).toUpperCase() : '';

    if (customer) {
      const initials = `${first + last}`;

      return (
        <NavDropdown title={initials} id="basic-nav-dropdown" className='account'>
          <NavDropdown.Item href={user && config.editProfileUrl.linkUrl ? config.editProfileUrl.linkUrl.destinationUrl : ''}>{config.editProfileUrl.linkText}</NavDropdown.Item>
          <NavDropdown.Item href={user && config.orderHistoryUrl.linkUrl ? config.orderHistoryUrl.linkUrl.destinationUrl : ''}>{config.orderHistoryUrl.linkText}</NavDropdown.Item>
          <NavDropdown.Item href={user && user.signOutUrl || ''}>{config.signOutTitle}</NavDropdown.Item>
        </NavDropdown>
      );
    }

    return <Nav.Link className='action action--sign-in' href={user && user.signInUrl}>{config.signInTitle}</Nav.Link>;
  }

  private _renderMainLevel(): JSX.Element[] | null {
    const { config } = this.props;

    const mainLevels = config.siteLinks!;

    const locale = this.props.context.actionContext.requestContext.locale;

    return mainLevels.map((item, idxMain) => {
      const secondLevel = item.siteLinkSubMenu as unknown as ISubMenuData[];
      const enableSiteLinkNewLable = item.siteLinkNewLabel;
      const newLabelText = item.siteLinkNewLableText;

      if (secondLevel && secondLevel.length > 0) {
        const idName = item.siteLinkName.replace(' ', '').toLowerCase();

        return (
          <NavDropdown key={idxMain} title={item.siteLinkName} renderMenuOnMount={true} id={idName} className='main-link'>
            <div className='dropdown-content' aria-labelledby='navbarDropdown'>
              {this._render2ndLevel(secondLevel)}
            </div>
          </NavDropdown>
        );
      } else {
        const linkStyle = item.siteLinkUrl.destinationUrl === '#' || item.siteLinkUrl.destinationUrl === undefined ? 'main-link no-link' : 'main-link';

        return (
          <div className={linkStyle}>{item.isExternalLink && <Nav.Link key={idxMain} href={item.siteLinkUrl.destinationUrl} onClick={this._handleExternalLinkClick}>{item.siteLinkName}{enableSiteLinkNewLable && <label className='mainlink-item-new'>{newLabelText}</label>}</Nav.Link>}
            {!item.isExternalLink && <Nav.Link key={idxMain} href={item.siteLinkUrl.destinationUrl} >{item.siteLinkName}{enableSiteLinkNewLable && <label className='mainlink-item-new'>{newLabelText}</label>}</Nav.Link>}
            {item.isExternalLink && <Popup showPopup={this.state.showExternalLinkPopup} name={item.siteLinkName} url={item.siteLinkUrl.destinationUrl} isMobile={isMobile(this.state.width)} isPortalPopup={true} locale={locale} callback={this._handleCallback} context={this.props
              .context} />}
          </div>
        );
      }
    });
  }

  private _handleCallback = () => {
    this.setState({ showPopup: false, showExternalLinkPopup: false });
  }

  private _handleSiteLinkClick = async () => {

    const currerntCart = await this.props.data.cart;
    const showPopupOnClickLogo = this.props.config.showPopupOnClickLogo;

    if (currerntCart && currerntCart.totalItemsInCart > 0 && showPopupOnClickLogo) {
      event?.preventDefault();
      this.setState({ showPopup: true });
    }
    else {
      this.setState({ showPopup: false });
    }

  }

  private _handleExternalLinkClick = async () => {

    const currerntCart = await this.props.data.cart;
    

    if (currerntCart && currerntCart.totalItemsInCart > 0) {
      event?.preventDefault();
      this.setState({ showExternalLinkPopup: true });
    }
    else {
      this.setState({ showExternalLinkPopup: false });
    }

  }

  private _render2ndLevel(secondLevel: ISubMenuData[]): JSX.Element[] | null {
    return secondLevel.map((item, idx2nd) => {
      const thirdLevel = item.subMenuLinks as unknown as ISubMenuLinkData[];

      return <ul key={idx2nd} aria-label={item.headingName}>{this._render3rdLevel(thirdLevel)}</ul>;
    });
  }

  private _render3rdLevel(thirdLevel: ISubMenuLinkData[]): JSX.Element[] | null {
    return thirdLevel.map((item, idx3rd) => {
      const linkStyle = item.linkUrl.destinationUrl === '' || item.linkUrl.destinationUrl === undefined ? 'no-link' : '';

      return <li className={linkStyle} key={idx3rd}><a href={item.linkUrl.destinationUrl}>{item.linkName}</a></li>;
    });
  }

  private _renderQuicklinksMenu(): JSX.Element[] | null {
    const { qLinks } = this.props;

    return qLinks.map((item, index) => {
      return (
        <div className='quicklink-item' key={index}>
          {item}
          {!isMobile(this.state.width) && index !== qLinks.length - 1 ? <p className='divider'>|</p> : null}
        </div>
      );
    });
  }

  private _renderLanguageMenu(): JSX.Element | null {
    const { config } = this.props;

    if (config.languages === undefined || config.languages.length === 0) {
      return null;
    }

    const languages = config.languages!;

    const mainIdx = languages.findIndex(item => item.isMainSiteLanguage === true);

    const mainLanguage = mainIdx === -1 ? languages[0] : languages[`${mainIdx}`];

    const options: ILanguagesData[] = [];

    languages.map(item => {
      if (item.languageName !== mainLanguage.languageName) {
        options.push(item);
      }
    });

    const langStyle = isMobile(this.state.width) ? 'language-wrapper ml-auto' : 'language-wrapper col-sm-2';

    return (
      <div className={langStyle}>
        <Dropdown>
          <Dropdown.Toggle id='dropdown-basic'>{mainLanguage.languageName}</Dropdown.Toggle>
          <Dropdown.Menu>{this._renderLanguageOptions(options)}</Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }

  private _renderLanguageOptions(options: ILanguagesData[]): JSX.Element[] | null {
    return options.map((item, index) => {
      return <Dropdown.Item key={index} href={item.languageUrl.destinationUrl}>{item.languageName}</Dropdown.Item>;
    });
  }

  private _onToggleCallback = () => {
    this.setState({ isMobileExpand: !this.state.isMobileExpand });
  }

  private _onToggleSearch = () => {
    this.setState({ isSearchExpand: !this.state.isSearchExpand });
  }

  private _updateDimensions = () => {
    this.setState({ width: window.innerWidth });
  };
  private _renderReactFragment = (items: React.ReactNode[]): JSX.Element | null => {
    return (
      <>
        {items && items.length > 0 ? items.map((slot: React.ReactNode, index: number) => {
          return (<React.Fragment key={index}>
            {slot}
          </React.Fragment>);
        }) : null}
      </>
    );
  }
}

export default EshopSiteMenuView;